// extracted by mini-css-extract-plugin
export default {"RowEmpty":"RowEmpty_RowEmpty__v24Rh","RowEmpty__Icon":"RowEmpty_RowEmpty__Icon__C9teZ","RowEmpty__Text":"RowEmpty_RowEmpty__Text__FCaTu"};